import "@/App.css";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import Services from "@/pages/Services";
import PublicEntities from "@/pages/PublicEntities";
import SmallBusiness from "@/pages/SmallBusiness";
import About from "@/pages/About";
import HowWeWork from "@/pages/HowWeWork";
import Contact from "@/pages/Contact";
import AccessibilityReport from "@/pages/AccessibilityReport";
import AccessibilityConformanceReport from "@/pages/AccessibilityConformanceReport";
import PrivacyPolicy from "@/pages/PrivacyPolicy";
import AdminLogin from "@/pages/AdminLogin";
import AdminDashboard from "@/pages/AdminDashboard";

// Scroll to top on route change
const ScrollToTop = () => {
  const { pathname } = useLocation();
  
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);
  
  return null;
};

// Layout wrapper to conditionally show header/footer
const Layout = ({ children }) => {
  const location = useLocation();
  const isAdminRoute = location.pathname.startsWith('/admin-dashboard');
  
  if (isAdminRoute) {
    return <>{children}</>;
  }
  
  return (
    <>
      {/* Skip Navigation Link - WCAG 2.4.1 Bypass Blocks */}
      <a 
        href="#main-content" 
        className="sr-only focus:not-sr-only focus:absolute focus:top-4 focus:left-4 focus:z-[100] focus:px-4 focus:py-2 focus:bg-[#1e3a5f] focus:text-white focus:rounded focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[#c84630]"
      >
        Skip to main content
      </a>
      <Header />
      <main id="main-content" tabIndex="-1">
        {children}
      </main>
      <Footer />
    </>
  );
};

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <ScrollToTop />
        <Layout>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/services" element={<Services />} />
            <Route path="/public-entities" element={<PublicEntities />} />
            <Route path="/small-business" element={<SmallBusiness />} />
            <Route path="/about" element={<About />} />
            <Route path="/how-we-work" element={<HowWeWork />} />
            <Route path="/contact" element={<Contact />} />
            <Route path="/accessibility" element={<AccessibilityReport />} />
            <Route path="/accessibility-conformance-report" element={<AccessibilityConformanceReport />} />
            <Route path="/privacy-policy" element={<PrivacyPolicy />} />
            {/* Admin Routes - Hidden from public navigation */}
            <Route path="/admin-dashboard/login" element={<AdminLogin />} />
            <Route path="/admin-dashboard" element={<AdminDashboard />} />
          </Routes>
        </Layout>
      </BrowserRouter>
    </div>
  );
}

export default App;
